import Api from './Api';

export default {
    check(voucher) {
        return Api.get(`check/voucher/${voucher}`);
    }
}